// SPDX-License-Identifier: EUPL-1.2
/*
 * Copyright (c) 2025, European Commission. Licensed under the EUPL-1.2
 * Authors:
*   Pierluigi Spedicato
 */

export const PALETTE = {
	BLUE_PRIMARY: '#004494',
	LIGHT_BLUE: '#E3F2FD',
	RED_PRIMARY: '#F44336',
	YELLOW_PRIMARY: '#FFEB3B'
};
